import React, { useState, useEffect, createContext } from "react"

const MobileContext = createContext({
  isMobile: false,
  isTablet: false,
  isMenuHidden: false,
  showBurger: false,
  toggleMenu: () => { },
  closeMenu: () => { },
  openMenu: () => { },
})

export const MobileProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [isStatic, setIsStatic] = useState(false)
  const [isMenuHidden, setMenuHidden] = useState(false)
  const [showBurger, setShowBurger] = useState(true)
  const [showDropDown, setShowDropDown] = useState(false)

  const toggleMenu = () => setMenuHidden(!isMenuHidden)
  const closeMenu = () => setMenuHidden(false)
  const openMenu = () => setMenuHidden(true)

  const onWindowSizeChange = () => {
    window.innerWidth > 780 ? setIsMobile(false) : setIsMobile(true)
    window.innerWidth > 1000 ? setIsStatic(false) : setIsStatic(true)
    window.innerWidth > 1200 ? setShowBurger(false) : setShowBurger(true)
    window.innerWidth < 1201 && window.innerWidth > 780 ? setIsTablet(true) : setIsTablet(false)
    window.innerWidth > 1185 ? setShowDropDown(false) : setShowDropDown(true)
  }

  useEffect(() => {
    onWindowSizeChange()

    window.addEventListener("resize", onWindowSizeChange)
    return () => {
      window.removeEventListener("resize", onWindowSizeChange)
    }
  }, [])

  return (
    <MobileContext.Provider
      value={{
        isMobile,
        isTablet,
        toggleMenu,
        closeMenu,
        openMenu,
        isMenuHidden,
        showBurger,
        isStatic,
        showDropDown,
      }}
    >
      {children}
    </MobileContext.Provider>
  )
}

export default MobileContext
